﻿import { PanelistCurrency } from '@/utils/types';

interface PanelCurrencyAmountParams {
  panelistCurrencyAmount: number;
  currencyMinorUnits?: number;
  panelistCurrency?: PanelistCurrency | null;
}

export const getPanelCurrencyAmount = ({
  panelistCurrencyAmount,
  currencyMinorUnits,
  panelistCurrency,
}: PanelCurrencyAmountParams): number => {
  const displayDecimals = panelistCurrency?.display_decimals ?? 0;
  const currencyRate = panelistCurrency?.currency_rate ?? 0;

  const panelistLedgerAmount =
    panelistCurrencyAmount * Math.pow(10, displayDecimals);
  const panelCurrencyAmount = panelistLedgerAmount * currencyRate;

  return parseFloat(panelCurrencyAmount.toFixed(currencyMinorUnits));
};
